"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteRankApi = deleteRankApi;
exports.getRankApi = getRankApi;
exports.getRankPageLink = getRankPageLink;
exports.listRankApi = listRankApi;
exports.listRankDetailApi = listRankDetailApi;
exports.saveRankApi = saveRankApi;
exports.settleRank = settleRank;
exports.updateRankApi = updateRankApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function listRankApi(params) {
  return (0, _request.default)({
    url: "/portal/system/rank/listRank",
    method: "get",
    params: params
  });
}
function saveRankApi(data) {
  return (0, _request.default)({
    url: "/portal/system/rank/saveRank",
    method: "post",
    data: data
  });
}
// 详情查询
function getRankApi(params) {
  return (0, _request.default)({
    url: "/portal/system/rank/getRank",
    method: "get",
    params: params
  });
}
// 删除
function deleteRankApi(data) {
  return (0, _request.default)({
    url: "/portal/system/rank/deleteRank",
    method: "post",
    data: data
  });
}
// 编辑
function updateRankApi(data) {
  return (0, _request.default)({
    url: "/portal/system/rank/updateRank",
    method: "post",
    data: data
  });
}
// 活动数据
function listRankDetailApi(params) {
  return (0, _request.default)({
    url: "/portal/system/rank/listRankDetail",
    method: "get",
    params: params
  });
}
// 结算
function settleRank(data) {
  return (0, _request.default)({
    url: "/portal/system/rank/settleRank",
    method: "post",
    data: data
  });
}
function getRankPageLink(params) {
  return (0, _request.default)({
    url: "/portal/system/rank/getRankPageLink",
    method: "get",
    params: params
  });
}